import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail } from "lucide-react";
import { NAV as NAV_EN, CONTACTS as CONTACTS_EN } from "../mock";
import { NAV as NAV_DE, CONTACTS as CONTACTS_DE } from "../mock.de";
import { getLang } from "../i18n";
import BrandMark from "./BrandMark";
import MonographModal from "./MonographModal";

const T = {
  en: {
    brand: "Nonlocal Field",
    blurb:
      "A nondual, nonlocal approach to awakening innate self-healing and coherence — creating the conditions in which wholeness can unfold naturally.",
    exploreTitle: "Explore",
    home: "Home",
    myStory: "My Story",
    fieldNotes: "Field Notes",
    faq: "FAQ",
    contacts: "Contacts",
    learnTitle: "Learn More",
    stepIn: "Step Into Coherence",
    monograph: "Download the Master Monograph (Free)",
    rights: "All rights reserved.",
    legal: "A non-medical contemplative practice · Held with quiet presence.",
    paths: { home: "/", myStory: "/my-story", fieldNotes: "/field-notes", faq: "/faq", contacts: "/contacts", impressum: "/impressum" },
  },
  de: {
    brand: "Nichtlokales Feld",
    blurb:
      "Ein nondualer, nichtlokaler Ansatz zur Erweckung der angeborenen Selbstheilung und Kohärenz — der die Bedingungen schafft, unter denen sich Ganzheit auf natürliche Weise entfalten kann.",
    exploreTitle: "Entdecken",
    home: "Startseite",
    myStory: "Meine Geschichte",
    fieldNotes: "Field Notes",
    faq: "FAQ",
    contacts: "Kontakt",
    learnTitle: "Mehr erfahren",
    stepIn: "Tritt in die Kohärenz ein",
    monograph: "Master-Monographie herunterladen (kostenlos)",
    rights: "Alle Rechte vorbehalten.",
    legal: "Eine nicht-medizinische kontemplative Praxis · Gehalten in stiller Präsenz.",
    paths: { home: "/de", myStory: "/de/meine-geschichte", fieldNotes: "/de/field-notes", faq: "/de/faq", contacts: "/de/kontakt", impressum: "/de/impressum" },
  },
};

const Footer = () => {
  const location = useLocation();
  const lang = getLang(location.pathname);
  const t = T[lang];
  const NAV = lang === "de" ? NAV_DE : NAV_EN;
  const CONTACTS = lang === "de" ? CONTACTS_DE : CONTACTS_EN;
  const learn = NAV.links.find((l) => l.dropdown);
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container-page">
        <div className="footer-grid">
          <div className="footer-brand-col">
            <div className="flex items-center gap-2">
              <BrandMark light />
              <span className="footer-brand-name" style={{ marginBottom: 0 }}>
                {t.brand}
              </span>
            </div>
            <p style={{ marginTop: "1rem", maxWidth: 340, color: "#9a9ca6", fontSize: "0.92rem" }}>
              {t.blurb}
            </p>
            <a
              href={`mailto:${CONTACTS.email}`}
              style={{ display: "inline-flex", alignItems: "center", gap: 8, marginTop: "1.1rem", fontSize: "0.92rem" }}
            >
              <Mail size={16} /> {CONTACTS.email}
            </a>
          </div>

          <div>
            <div className="footer-title">{t.exploreTitle}</div>
            <div className="footer-col">
              <Link to={t.paths.home}>{t.home}</Link>
              <Link to={t.paths.myStory}>{t.myStory}</Link>
              <Link to={t.paths.fieldNotes}>{t.fieldNotes}</Link>
              <Link to={t.paths.faq}>{t.faq}</Link>
              <Link to={t.paths.contacts}>{t.contacts}</Link>
            </div>
          </div>

          <div>
            <div className="footer-title">{t.learnTitle}</div>
            <div className="footer-col">
              {learn?.dropdown.map((d) => (
                <Link key={d.to} to={d.to}>
                  {d.label}
                </Link>
              ))}
              <Link to={t.paths.contacts}>{t.stepIn}</Link>
              <MonographModal>
                <button type="button" className="footer-link-btn">
                  {t.monograph}
                </button>
              </MonographModal>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {year} {NAV.brand}. {t.rights}</span>
          <span className="footer-legal">
            <Link to={t.paths.impressum}>Impressum</Link>
            <span className="footer-dot">·</span>
            {t.legal}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
